import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { getNodeApiUrl } from '../config/api.config';
import { toast } from 'react-toastify';

const MCPServer = () => {
  const [loading, setLoading] = useState(false);
  const [tokenResult, setTokenResult] = useState(null);
  const [error, setError] = useState(null);
  const [accountId, setAccountId] = useState('');
  
  // Ottieni i dati dell'account corrente dal Redux store
  const account = useSelector(state => state.account);
  
  useEffect(() => {
    // Se l'utente è loggato e l'account è disponibile, imposta l'accountId
    if (account && account.data && account.data._id) {
      setAccountId(account.data._id);
    }
  }, [account]);

  const handleGetMCPToken = async () => {
    if (!accountId) {
      setError('ID account non valido');
      return;
    }

    setLoading(true);
    setError(null);
    setTokenResult(null);

    try {
      // Usa getNodeApiUrl per ottenere l'URL completo dell'endpoint
      const response = await axios.post(getNodeApiUrl('/auth/mcp-token'), { 
        accountId 
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('installamelo-auth-token')}`
        }
      });

      if (response.data && !response.data.error) {
        setTokenResult(response.data);
        console.log('Token MCP ottenuto:', response.data);
      } else {
        setError(response.data?.message || 'Errore sconosciuto');
      }
    } catch (err) {
      console.error('Errore durante la richiesta del token MCP:', err);
      setError(err.response?.data?.message || err.message || 'Errore durante la comunicazione con il server');
    } finally {
      setLoading(false);
    }
  };

  // Formatta una data ISO in formato leggibile
  const formatDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);
    return date.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header bg-transparent border-bottom">
                <h5 className="card-title mb-0">Gestione MCP Server</h5>
              </div>
              <div className="card-body">
                <h4 className="mb-4">Test Autenticazione MCP Server</h4>
                
                <div className="form-group mb-3">
                  <label htmlFor="accountId">ID Account</label>
                  <input
                    type="text"
                    className="form-control"
                    id="accountId"
                    value={accountId}
                    onChange={(e) => setAccountId(e.target.value)}
                    placeholder="Inserisci l'ID dell'account"
                  />
                  <small className="form-text text-muted">
                    Verrà utilizzato l'ID dell'account corrente se non specificato diversamente.
                  </small>
                </div>

                <button
                  type="button"
                  className={`btn btn-primary mt-3 ${loading ? 'disabled' : ''}`}
                  onClick={handleGetMCPToken}
                  disabled={loading}
                >
                  {loading ? 'Richiesta in corso...' : 'Ottieni Token MCP'}
                </button>

                {error && (
                  <div className="alert alert-danger mt-4" role="alert">
                    <h5>Errore</h5>
                    <p>{error}</p>
                  </div>
                )}

                {tokenResult && (
                  <div className="alert alert-success mt-4" role="alert">
                    <h5>Token MCP ottenuto {tokenResult.cached ? '(dalla cache)' : '(nuovo)'}</h5>
                    <div className="token-info mt-3">
                      {tokenResult.token && (
                        <p>
                          <strong>Token:</strong> 
                          <span className="font-monospace">
                            {tokenResult.token.substring(0, 20)}...{tokenResult.token.substring(tokenResult.token.length - 5)}
                          </span>
                        </p>
                      )}
                      {tokenResult.message && (
                        <p><strong>Messaggio:</strong> {tokenResult.message}</p>
                      )}
                      {tokenResult.expires_at && (
                        <p><strong>Scade il:</strong> {formatDateTime(tokenResult.expires_at)}</p>
                      )}
                      <p>
                        <strong>Provenienza:</strong> {tokenResult.cached ? 'Cache' : 'Richiesta fresca al server MCP'}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MCPServer;
